import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useAppSelector } from "../../../app/hooks";
import { Transitions } from "../../../common/components/Transitions";
import { NavItems } from "../../../common/helpers/navigation";
import { sleepFor } from "../../../common/helpers/countHelper";
import { AssessmentShell } from "../components/AssessmentShell";
import VideoPlayer from "../../../common/components/VideoPlayer";
import { getInstructionFromStep } from "../../../common/helpers/instructionHelper";
import { LCountDown } from "../../../common/components/LCountDown";

export const AssessmentInstructionCountdown = (): JSX.Element => {
    const [errorLoadingVideo, setErrorLoadingVideo] = useState(false);
    const [currentCaption, setCurrentCaption] = useState("");
    const [startCountDown, setStartCountDown] = useState(false);

    const navigate = useNavigate();

    const currentInstruction = useAppSelector((x) => x.assessmentFlow.flows[x.assessmentFlow.currentFlow]);

    const assessmentInstruction = useAppSelector((x) =>
        getInstructionFromStep(x.assessmentForm.instructions, currentInstruction.name)
    );

    useEffect(() => {
        if (errorLoadingVideo) {
            const instructions = assessmentInstruction.instructionText.split(";");

            instructions.forEach((instruction, index) => {
                setTimeout(() => {
                    setCurrentCaption(instruction);
                }, index * 3 * 1000);
            });

            setTimeout(() => {
                void handleOnEnd();
            }, (instructions.length + 1) * 3 * 1000);
        }
    }, [assessmentInstruction, errorLoadingVideo]);

    const handleOnVideoError = (): void => {
        setErrorLoadingVideo(true);
    };

    const handleOnEnd = async (): Promise<void> => {
        if (currentInstruction.name === "List A Free Recall 2") {
            navigate(NavItems.Assessments.AssessmentFreeRecall.path);
            return;
        }

        await sleepFor(3);
        setStartCountDown(true);
    };

    return (
        <AssessmentShell>
            {!startCountDown ? (
                errorLoadingVideo ? (
                    <div className="columns">
                        <div className="column">
                            <Transitions currentCaption={currentCaption} />
                        </div>
                    </div>
                ) : (
                    <VideoPlayer
                        url={assessmentInstruction.instructionVideoUrl}
                        onLoadError={handleOnVideoError}
                        onEnd={handleOnEnd}
                    />
                )
            ) : (
                <LCountDown from={3} onDone={() => navigate(NavItems.Assessments.AssessmentFreeRecall.path)} />
            )}
        </AssessmentShell>
    );
};
